import type { KpiItem } from "../types.js";

interface KpiRowProps {
  items: KpiItem[];
}

export function KpiRow({ items }: KpiRowProps) {
  return (
    <div
      className={`mb-[10px] grid grid-cols-2 gap-[10px] ${items.length === 5 ? "xl:grid-cols-5" : "xl:grid-cols-4"}`}
    >
      {items.map((item) => (
        <div key={item.name} className="rounded-xl border border-border bg-panel-3 p-[10px]">
          <div className="mb-[6px] text-xs text-text-secondary">{item.name}</div>
          <div className="text-2xl font-bold text-text-primary">{item.value}</div>
          <div className="mt-[6px] text-xs text-[#a7badf]">{item.sub}</div>
        </div>
      ))}
    </div>
  );
}
